import { Pipe, PipeTransform } from '@angular/core';

import { srtTimeToSeconds } from 'rev-shared/util/SrtUtil';

/**
 * @param timestamp expected format is in HH:mm:ss,SSS (SRT timestamp format) e.g. 00:00:01,000
 * @returns timestamp in seconds
 */
@Pipe({ name: 'vbSrtTimeToSeconds' })
export class vbSrtTimeToSeconds implements PipeTransform {
	public transform(timestamp: string): number {
		return srtTimeToSeconds(timestamp);
	}
}
